import React from 'react';
import { FormattedMessage } from 'react-intl';
import Immutable from 'immutable';

import { ExpandableList } from 'app/components/shared/Expandable';
import Heading from 'app/components/shared/Heading';
import DistinctionItem from './DistinctionItem';

import './Distinctions.scss';

function renderDistinctionList(title, items) {
  return (
    <div className="list">
      <Heading tagName="h4" size="modest">
        {title}
      </Heading>
      <ExpandableList
        className="distinction-list"
        collapseCount={3}
        expandLinkHref="#show-more-distinctions"
        getItemKey={item => `${item.get('title')}-${item.get('subtitle')}}`}
        itemClassName="distinction-item"
        list={items}
        renderItem={item => <DistinctionItem item={item} />}
        stacked
      />
    </div>
  );
}

const distinctions = Immutable.fromJS({
  awards: [
    {
      title: 'The Reading List',
      subtitle: 'Winner, Science Fiction, 2012',
      url: '/explore/awards/524289'
    }
  ],
  bestsellers: [
    {
      title: 'New York Times',
      subtitle: 'Hardcover Fiction'
    }
  ]
});

export default class Distinctions extends React.PureComponent {
  render() {
    return (
      <div className="cp-bib-distinctions">
        <Heading tagName="h3" size="medium" variant>
          <FormattedMessage id="awards_and_bestsellers" />
        </Heading>

        <div className="lists">
          {renderDistinctionList(<FormattedMessage id="awards" />, distinctions.get('awards'))}

          {renderDistinctionList(<FormattedMessage id="bestsellers" />, distinctions.get('bestsellers'))}
        </div>
      </div>
    );
  }
}
